import { faCheck, faMinus } from '@fortawesome/pro-regular-svg-icons';
import { useId } from '@reach/auto-id';
import PropTypes from 'prop-types';
import { forwardRef, useEffect, useState, useRef } from 'react';

import { Icon } from '../Icons';

import '../Forms/styles/checkAndRadioStyles.css';

/**
 * The IndeterminateCheckbox instance is documented here:
 * https://github.com/tannerlinsley/react-table/tree/master/examples/row-selection-and-pagination
 */

const IndeterminateCheckbox = forwardRef(
  ({ id, indeterminate, labelText, ...rest }, ref) => {
    const elementId = useId(id);
    const defaultRef = useRef();
    const resolvedRef = ref || defaultRef;
    const { checked } = rest;
    const [checkState, setCheckState] = useState(checked);

    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
      if (indeterminate) {
        setCheckState('mixed');
      } else {
        setCheckState(checked);
      }
    }, [checked, resolvedRef, indeterminate]);

    const icon = checkState === 'mixed' ? faMinus : faCheck;

    return (
      <label className="custom-checkbox min-h-8" htmlFor={elementId}>
        <input
          aria-checked={checkState}
          className="checkbox"
          id={elementId}
          ref={resolvedRef}
          type="checkbox"
          {...rest}
        />
        <Icon icon={icon} />
        <span className="sr-only">{labelText}</span>
      </label>
    );
  },
);

IndeterminateCheckbox.defaultProps = {
  id: null,
};

IndeterminateCheckbox.propTypes = {
  id: PropTypes.string,
  indeterminate: PropTypes.bool.isRequired,
  labelText: PropTypes.string.isRequired,
};

export default IndeterminateCheckbox;
